import { ListFilterCustomSelect } from "../../components/ListFilterCustomSelect";
import { BINARY_FILTER_OPTIONS } from "../../utils/listFilterQuery";
import { FLOW_TEXT_INPUT_BASE } from "../../styles/twDesignPrimitives";

type Props = {
  searchTerm: string;
  hasDocuments: string;
  hasDocumentLink: string;
  onSearchChange: (value: string) => void;
  onHasDocumentsChange: (value: string) => void;
  onHasDocumentLinkChange: (value: string) => void;
};

export function DocumentsListFilters({
  searchTerm,
  hasDocuments,
  hasDocumentLink,
  onSearchChange,
  onHasDocumentsChange,
  onHasDocumentLinkChange,
}: Props) {
  return (
    <div className="mb-6 mt-4 flex w-full flex-col gap-3 md:flex-row md:flex-wrap md:items-end">
      <label className="flex min-w-0 flex-1 flex-col gap-1 text-left text-xs font-medium text-slate-600 md:max-w-md">
        Busca
        <input
          className={`${FLOW_TEXT_INPUT_BASE} !font-[inherit]`}
          value={searchTerm}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Buscar por nome do cliente ou código do imóvel..."
        />
      </label>

      <ListFilterCustomSelect
        label="Enviou documentos"
        value={hasDocuments}
        options={BINARY_FILTER_OPTIONS}
        onChange={onHasDocumentsChange}
      />
      <ListFilterCustomSelect
        label="Link gerado"
        value={hasDocumentLink}
        options={BINARY_FILTER_OPTIONS}
        onChange={onHasDocumentLinkChange}
      />
    </div>
  );
}
